// extracted by mini-css-extract-plugin
module.exports = {"expectationsSwitcherRoot":"etTEv6cx","customButtonGroup":"nKN9JSD5"};